import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, CaptureThumb, EmptyState } from "@/components/common";
import { Search as SearchIcon, Users, MapPin, File } from "@/lib/icons";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [res, setRes] = useState(null);

  useEffect(() => {
    if (!q) return;
    api.get("/search", { params: { q } }).then((r) => setRes(r.data)).catch(() => {});
  }, [q]);

  const total = res ? res.captures.length + res.collections.length + res.people.length + res.places.length : 0;

  return (
    <div className="max-w-5xl mx-auto">
      <PageHeader eyebrow="Catalog" color="#3B82F6" title={`Results for “${q}”`} subtitle={res ? `${total} matches across captures, collections, people and places` : "Searching…"} />
      {res && total === 0 && <EmptyState icon={SearchIcon} title="No matches" hint="Search looks across titles, notes, tags, people and places. Audio/image contents are not searched in this release." />}
      {res && (
        <div className="space-y-8">
          {res.captures.length > 0 && (
            <div>
              <h3 className="font-display text-sm text-slate-400 mb-3">Captures</h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">{res.captures.map((c) => <CaptureThumb key={c.id} cap={c} />)}</div>
            </div>
          )}
          {res.collections.length > 0 && (
            <div>
              <h3 className="font-display text-sm text-slate-400 mb-3">Collections</h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {res.collections.map((c) => <Link key={c.id} to={`/collections/${c.id}`} className="dl-card p-4 flex items-center gap-3"><File size={16} style={{ color: c.color }} /><span className="text-white text-sm">{c.name}</span></Link>)}
              </div>
            </div>
          )}
          {(res.people.length > 0 || res.places.length > 0) && (
            <div className="grid sm:grid-cols-2 gap-6">
              {res.people.length > 0 && <div><h3 className="font-display text-sm text-slate-400 mb-3">People</h3>{res.people.map((p) => <div key={p.id} className="dl-card p-3 mb-2 flex items-center gap-2"><Users size={15} className="text-red-400" /><span className="text-white text-sm">{p.name}</span></div>)}</div>}
              {res.places.length > 0 && <div><h3 className="font-display text-sm text-slate-400 mb-3">Places</h3>{res.places.map((p) => <div key={p.id} className="dl-card p-3 mb-2 flex items-center gap-2"><MapPin size={15} className="text-teal-400" /><span className="text-white text-sm">{p.name}</span></div>)}</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
